module.exports = __webpack_public_path__ + "src/assets/images/logos/carriers/U2//U2Logo.jpg";